export default __webpack_public_path__ + "static/media/vaman-plastics.8e4e8937.webp";